import { useTranslation } from 'react-i18next';
import { usePortalBookingHref } from '@/hooks/usePortalBookingHref';
import { PortalIcon } from '@/components/portal/PortalIcon';

/**
 * Shared Patient Portal CTA that opens the existing /book/:clinicSlug flow.
 */
export function PortalBookAppointmentButton({ className }: { className?: string }) {
  const { t } = useTranslation();
  const href = usePortalBookingHref();
  if (!href) return null;

  return (
    <a href={href} data-testid="portal-book-new-appointment" className={`btn btn-primary ${className ?? ''}`}>
      <PortalIcon name="calendarPlus" size="sm" />
      {t('portal.book_new')}
    </a>
  );
}
